__turbopack_context__.v({
  "container": "Analysis-module__8GweoG__container",
  "leftColumn": "Analysis-module__8GweoG__leftColumn",
  "rightColumn": "Analysis-module__8GweoG__rightColumn",
});
